(() => {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];
  let activeCurrency = window.Shopify?.currency?.active || 'USD';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: activeCurrency }).format((cents || 0) / 100);
  const escapeHtml = value => String(value || '').replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  const campaignKeys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
  const currentAttribution = Object.fromEntries(campaignKeys.map(key => [key, new URLSearchParams(window.location.search).get(key) || '']).filter(([,value]) => value));
  const readStoredAttribution = key => { try { return JSON.parse(window.localStorage.getItem(key) || '{}'); } catch (_) { return {}; } };
  if (Object.keys(currentAttribution).length) {
    try {
      if (!window.localStorage.getItem('nyum_first_touch')) window.localStorage.setItem('nyum_first_touch', JSON.stringify({ ...currentAttribution, landing_page: window.location.pathname }));
      window.localStorage.setItem('nyum_last_touch', JSON.stringify({ ...currentAttribution, landing_page: window.location.pathname }));
    } catch (_) {}
  }
  const attribution = { ...readStoredAttribution('nyum_first_touch'), ...readStoredAttribution('nyum_last_touch') };
  const track = (name, detail = {}) => {
    const payload = { ...attribution, ...detail, page_path: window.location.pathname };
    try { window.Shopify?.analytics?.publish?.(`nyum_${name}`, payload); } catch (error) { console.debug(error); }
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: `nyum_${name}`, ...payload }); } catch (error) { console.debug(error); }
    try { window._learnq = window._learnq || []; window._learnq.push(['track', `NYUM ${name}`, payload]); } catch (error) { console.debug(error); }
  };

  // Mobile navigation is isolated in nyum-mobile-menu.js.

  const layer = qs('[data-nyum-cart-layer]');
  const itemsRoot = qs('[data-nyum-cart-items]');
  const emptyRoot = qs('[data-nyum-cart-empty]');
  const upgradeRoot = qs('[data-nyum-cart-upgrade]');
  const protocolRoot = qs('[data-nyum-cart-protocol]');
  const recommendationsRoot = qs('[data-nyum-cart-recommendations]');
  const config = qs('[data-nyum-cart-config]')?.dataset || {};

  const openCart = () => {
    if (!layer) return;
    layer.classList.add('is-open');
    layer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };
  const closeCart = () => {
    if (!layer) return;
    layer.classList.remove('is-open');
    layer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
  qsa('[data-nyum-cart-open]').forEach(button => button.addEventListener('click', async () => { await refreshCart(); openCart(); }));
  qsa('[data-nyum-cart-close]').forEach(button => button.addEventListener('click', closeCart));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeCart(); });

  async function cartRequest(url, options = {}) {
    const response = await fetch(url, { credentials: 'same-origin', ...options });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  }

  function cadenceLabel(value) {
    const source = String(value || '').trim();
    const match = source.match(/(\d+)\s*(day|week|month|year)s?/i);
    if (!match) return source ? `EVERY ${source.toUpperCase()}` : '';
    return `EVERY ${match[1]} ${match[2].toUpperCase()}${Number(match[1]) === 1 ? '' : 'S'}`;
  }

  function purchaseDetails(item) {
    const allocation = item?.selling_plan_allocation;
    if (!allocation) return { isSubscription: false, label: 'ONE-TIME PURCHASE', interval: '', discountPercent: 0 };
    const compareAt = Number(allocation.compare_at_price || item.original_price || item.price || 0);
    const planPrice = Number(allocation.price || item.final_price || item.price || 0);
    const discountPercent = compareAt > planPrice ? Math.round(((compareAt - planPrice) * 100) / compareAt) : 0;
    const option = allocation.selling_plan?.options?.[0];
    const cadenceSource = typeof option === 'string' ? option : (option?.value || allocation.selling_plan?.name || '');
    return {
      isSubscription: true,
      label: discountPercent > 0 ? `SUBSCRIBE & SAVE ${discountPercent}%` : 'AUTOMATIC DELIVERY',
      interval: cadenceLabel(cadenceSource),
      discountPercent
    };
  }

  function renderUpgrade(cart) {
    if (!upgradeRoot) return;
    const forceSingle = cart.items.find(item => String(item.variant_id) === String(config.forceSingle) && !item.selling_plan_allocation);
    const fenvirSingle = cart.items.find(item => String(item.variant_id) === String(config.fenvirSingle) && !item.selling_plan_allocation);
    const forceProtocol = cart.items.find(item => String(item.variant_id) === String(config.forceProtocol) && !item.selling_plan_allocation);
    const fenvirProtocol = cart.items.find(item => String(item.variant_id) === String(config.fenvirProtocol) && !item.selling_plan_allocation);
    const candidate = forceSingle || fenvirSingle || forceProtocol || fenvirProtocol;
    if (!candidate) { upgradeRoot.hidden = true; upgradeRoot.innerHTML = ''; return; }
    const isForce = !!(forceSingle || forceProtocol);
    const isExtendedUpgrade = !!(forceProtocol || fenvirProtocol);
    const targetVariant = isForce ? (isExtendedUpgrade ? config.forceExtended : config.forceProtocol) : (isExtendedUpgrade ? config.fenvirExtended : config.fenvirProtocol);
    const productName = isForce ? 'Fucoidan Force' : 'Fenvir';
    upgradeRoot.hidden = false;
    upgradeRoot.innerHTML = isExtendedUpgrade
      ? `<p>EXTEND YOUR PROTOCOL</p><b>Move ${escapeHtml(productName)} to the 6-Bottle Protocol (4 + 2 Free) and secure two complimentary bottles.</b><button type="button" data-nyum-upgrade data-key="${escapeHtml(candidate.key)}" data-variant="${escapeHtml(targetVariant)}">UPGRADE TO 6-BOTTLE PROTOCOL →</button>`
      : `<p>YOU'RE LEAVING A FREE BOTTLE BEHIND</p><b>Move ${escapeHtml(productName)} to the 3-Bottle Protocol (2 + 1 Free) and secure one complimentary bottle.</b><button type="button" data-nyum-upgrade data-key="${escapeHtml(candidate.key)}" data-variant="${escapeHtml(targetVariant)}">UPGRADE TO 3-BOTTLE PROTOCOL →</button>`;
  }

  function renderProtocol(cart) {
    if (!protocolRoot) return;
    const forceSinglePrice = Number(config.forceSinglePrice || 0);
    const fenvirSinglePrice = Number(config.fenvirSinglePrice || 0);
    const variants = {
      [String(config.forceSingle)]: { level: 1, savings: 0, name: 'Fucoidan Force' },
      [String(config.fenvirSingle)]: { level: 1, savings: 0, name: 'Fenvir' },
      [String(config.forceProtocol)]: { level: 2, savings: Math.max(0, (forceSinglePrice * 3) - Number(config.forceProtocolPrice || 0)), name: 'Fucoidan Force' },
      [String(config.fenvirProtocol)]: { level: 2, savings: Math.max(0, (fenvirSinglePrice * 3) - Number(config.fenvirProtocolPrice || 0)), name: 'Fenvir' },
      [String(config.forceExtended)]: { level: 3, savings: Math.max(0, (forceSinglePrice * 6) - Number(config.forceExtendedPrice || 0)), name: 'Fucoidan Force' },
      [String(config.fenvirExtended)]: { level: 3, savings: Math.max(0, (fenvirSinglePrice * 6) - Number(config.fenvirExtendedPrice || 0)), name: 'Fenvir' }
    };
    const protocolItems = cart.items.filter(item => variants[String(item.variant_id)]);
    const savingsRow = qs('[data-nyum-cart-savings-row]');
    const savingsAmount = qs('[data-nyum-cart-savings]');
    if (!protocolItems.length) {
      protocolRoot.hidden = true;
      if (savingsRow) savingsRow.hidden = true;
      return;
    }
    protocolRoot.hidden = false;
    const subscriptionItem = protocolItems.find(item => item.selling_plan_allocation);
    const matched = protocolItems.map(item => ({ item, state: variants[String(item.variant_id)] })).filter(match => !match.item.selling_plan_allocation);
    const best = matched.sort((a, b) => b.state.level - a.state.level)[0];
    const level = best?.state.level || 0;
    const savings = matched.reduce((sum, match) => sum + (match.state.savings * match.item.quantity), 0);
    qsa('[data-nyum-protocol-step]', protocolRoot).forEach(step => {
      const stepLevel = Number(step.dataset.nyumProtocolStep);
      step.classList.toggle('is-active', level >= stepLevel);
      step.classList.toggle('is-current', level === stepLevel);
    });
    const bar = qs('[data-nyum-protocol-bar]', protocolRoot);
    if (bar) bar.style.width = ({ 0: 0, 1: 18, 2: 59, 3: 100 }[level] || 0) + '%';
    const badge = qs('[data-nyum-protocol-badge]', protocolRoot);
    const copy = qs('[data-nyum-protocol-copy]', protocolRoot);
    const subscription = subscriptionItem ? purchaseDetails(subscriptionItem) : null;
    if (badge) badge.textContent = level === 3 ? '6-BOTTLE PROTOCOL' : level === 2 ? '3-BOTTLE PROTOCOL' : level === 1 ? 'SINGLE BOTTLE' : subscription ? subscription.label : 'CHOOSE YOUR LEVEL';
    if (copy) copy.textContent = level === 3
      ? `${best.state.name}: two complimentary bottles secured. ${money(savings)} saved versus six singles.`
      : level === 2
        ? `${best.state.name}: one complimentary bottle secured. ${money(savings)} saved versus three singles.`
        : level === 1
          ? `Move ${best.state.name} to the 3-Bottle Protocol (2 + 1 Free) to secure one complimentary bottle.`
          : subscription
            ? `${subscriptionItem.product_title}: ${subscription.label.toLowerCase()} · ${subscription.interval.toLowerCase()}. BOGO protocols remain separate one-time offers.`
            : 'Add Fucoidan Force or Fenvir to choose a protocol.';
    if (savingsRow) savingsRow.hidden = savings <= 0;
    if (savingsAmount) savingsAmount.textContent = money(savings);
  }

  function renderRecommendations(cart) {
    if (!recommendationsRoot) return;
    const handles = new Set(cart.items.map(item => item.handle));
    const cards = qsa('[data-nyum-cart-rec]', recommendationsRoot);
    cards.forEach(card => { card.hidden = handles.has(card.dataset.productHandle); });
    recommendationsRoot.hidden = !cart.item_count || !cards.some(card => !card.hidden);
  }

  function renderCart(cart) {
    if (!layer || !itemsRoot) return;
    if (cart.currency) activeCurrency = cart.currency;
    layer.classList.toggle('has-items', cart.item_count > 0);
    qsa('[data-nyum-cart-count]').forEach(node => node.textContent = cart.item_count);
    const headingCount = qs('[data-nyum-cart-heading-count]');
    if (headingCount) headingCount.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'ITEM' : 'ITEMS'}`;
    const total = qs('[data-nyum-cart-total]');
    if (total) total.textContent = money(cart.total_price);
    const threshold = 5000;
    const remaining = Math.max(0, threshold - cart.total_price);
    const bar = qs('[data-nyum-shipping-bar]');
    if (bar) bar.style.width = `${Math.min(100, (cart.total_price / threshold) * 100)}%`;
    const shippingCopy = qs('[data-nyum-shipping-copy]');
    if (shippingCopy) shippingCopy.textContent = remaining > 0 ? `${money(remaining)} away from complimentary shipping` : 'Complimentary shipping unlocked';
    renderProtocol(cart);
    renderRecommendations(cart);
    if (!cart.item_count) {
      itemsRoot.innerHTML = '';
      if (emptyRoot) emptyRoot.hidden = false;
      if (upgradeRoot) upgradeRoot.hidden = true;
      return;
    }
    if (emptyRoot) emptyRoot.hidden = true;
    itemsRoot.innerHTML = cart.items.map(item => {
      const purchase = purchaseDetails(item);
      const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return `<article class="nyum-cart-line">
        <a href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image || '')}" alt="${escapeHtml(item.product_title)}" width="76" height="88" loading="lazy" decoding="async"></a>
        <div>
          <h3>${escapeHtml(item.product_title.replace(/®.*$/,'®').replace(/™.*$/,'™'))}</h3>
          ${variantTitle ? `<p class="nyum-cart-line__variant">${escapeHtml(variantTitle)}</p>` : ''}
          <div class="nyum-cart-line__purchase ${purchase.isSubscription ? 'is-subscription' : 'is-one-time'}">
            <span>${escapeHtml(purchase.label)}</span>
            ${purchase.interval ? `<b>${escapeHtml(purchase.interval)}</b>` : ''}
          </div>
          <div class="nyum-cart-line__qty"><button type="button" data-nyum-qty data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity - 1}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-nyum-qty data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button></div>
        </div>
        <div><b>${money(item.final_line_price)}</b><button class="nyum-cart-line__remove" type="button" data-nyum-qty data-key="${escapeHtml(item.key)}" data-quantity="0">REMOVE</button></div>
      </article>`;
    }).join('');
    renderUpgrade(cart);
  }

  async function refreshCart() {
    try { const cart = await cartRequest('/cart.js'); renderCart(cart); return cart; }
    catch (error) { console.warn(error); return null; }
  }

  layer?.addEventListener('click', async event => {
    const quantityButton = event.target.closest('[data-nyum-qty]');
    if (quantityButton) {
      quantityButton.disabled = true;
      try {
        const cart = await cartRequest('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: quantityButton.dataset.key, quantity: Number(quantityButton.dataset.quantity) }) });
        renderCart(cart);
      } catch (error) { console.warn(error); quantityButton.disabled = false; }
      return;
    }
    const upgradeButton = event.target.closest('[data-nyum-upgrade]');
    if (upgradeButton) {
      upgradeButton.disabled = true;
      upgradeButton.textContent = 'UPGRADING…';
      try {
        track('cart_upgrade', { variant_id: upgradeButton.dataset.variant });
        await cartRequest('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: upgradeButton.dataset.key, quantity: 0 }) });
        await cartRequest('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(upgradeButton.dataset.variant), quantity: 1 }] }) });
        await refreshCart();
      } catch (error) { console.warn(error); upgradeButton.disabled = false; upgradeButton.textContent = 'TRY AGAIN'; }
      return;
    }
    const recommendationButton = event.target.closest('[data-nyum-cart-rec-add]');
    if (recommendationButton) {
      recommendationButton.disabled = true;
      recommendationButton.textContent = 'ADDING…';
      try {
        track('cart_recommendation_added', { variant_id: recommendationButton.dataset.variant });
        await cartRequest('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(recommendationButton.dataset.variant), quantity: 1 }] }) });
        await refreshCart();
      } catch (error) { console.warn(error); recommendationButton.disabled = false; recommendationButton.textContent = 'TRY AGAIN'; }
    }
  });

  qsa('[data-nyum-add-form]').forEach(form => form.addEventListener('submit', async event => {
    event.preventDefault();
    /* NYUM draft submit-field recovery */
    const selectedSupply = form.querySelector('[name="nyum_supply"]:checked');
    const idField = form.querySelector('input[name="id"]');
    if (selectedSupply && idField) idField.value = selectedSupply.value;
    const quantityField = form.querySelector('input[name="quantity"]');
    if (quantityField && !quantityField.value) quantityField.value = '1';
    const submit = form.querySelector('[type="submit"]');
    const original = submit?.textContent;
    if (submit) { submit.disabled = true; submit.textContent = 'ADDING…'; }
    try {
      track('add_to_bag', { variant_id: String(new FormData(form).get('id') || ''), purchase_type: new FormData(form).get('selling_plan') ? 'subscription' : 'one_time' });
      await cartRequest('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
      await refreshCart();
      openCart();
    } catch (error) {
      console.warn(error);
      HTMLFormElement.prototype.submit.call(form);
    } finally {
      if (submit) { submit.disabled = false; submit.textContent = original; }
    }
  }));

  const productRoot = qs('[data-nyum-product-root]');
  if (productRoot) {
    const productForm = qs('[data-nyum-pdp-form]', productRoot);
    const idInput = qs('[data-nyum-variant-id]', productRoot);
    const addButton = qs('[data-nyum-pdp-add]', productRoot);
    const stickyLabel = qs('[data-nyum-sticky-label]', productRoot);
    const stickyPrice = qs('[data-nyum-sticky-price]', productRoot);
    const valueLine = qs('[data-nyum-pdp-value-line]', productRoot);
    const supplyRadios = qsa('[name="nyum_supply"]', productRoot);
    const syncSupply = (radio, shouldTrack = false) => {
      if (!radio) return;
      qsa('.nyum-v2-supply', productRoot).forEach(card => card.classList.remove('is-selected'));
      radio.closest('.nyum-v2-supply')?.classList.add('is-selected');
      if (idInput) idInput.value = radio.value;
      if (addButton) addButton.textContent = `ADD ${radio.dataset.ctaLabel || radio.dataset.label} · ${radio.dataset.price} →`;
      if (valueLine) valueLine.textContent = radio.dataset.valueLine || '';
      if (stickyLabel) stickyLabel.textContent = `${radio.dataset.label} · ${radio.dataset.title}`;
      if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
      if (shouldTrack) track('bundle_selected', { product: productRoot.dataset.productHandle, variant_id: radio.value, offer: radio.dataset.label });
    };
    supplyRadios.forEach(radio => radio.addEventListener('change', () => syncSupply(radio, true)));
    syncSupply(qs('[name="nyum_supply"]:checked', productRoot));
    const subscriptionRoot = qs('[data-nyum-subscription]', productRoot);
    const sellingPlanInput = qs('[data-nyum-selling-plan]', productRoot);
    if (subscriptionRoot && sellingPlanInput) {
      const purchaseRadios = qsa('[name="nyum_purchase_type"]', subscriptionRoot);
      const planRadios = qsa('[name="nyum_plan_choice"]', subscriptionRoot);
      const plans = qs('.nyum-v2-subscription__plans', subscriptionRoot);
      const syncPurchaseType = () => {
        const singleVariant = String(subscriptionRoot.dataset.singleVariant || '');
        const singleSelected = String(idInput?.value || '') === singleVariant;
        subscriptionRoot.hidden = !singleSelected;
        if (!singleSelected) {
          const oneTime = qs('[name="nyum_purchase_type"][value="one-time"]', subscriptionRoot);
          if (oneTime) oneTime.checked = true;
        }
        const subscribe = singleSelected && qs('[name="nyum_purchase_type"]:checked', subscriptionRoot)?.value === 'subscribe';
        const selectedPlan = qs('[name="nyum_plan_choice"]:checked', subscriptionRoot);
        /* Seal can replace the original hidden input after this script starts.
           Always update the field that is currently inside the submitted form. */
        const activeSellingPlanInput = qs('[name="selling_plan"]', productForm) || sellingPlanInput;
        qsa('.nyum-v2-subscription__choices > label', subscriptionRoot).forEach(label => label.classList.toggle('is-selected', label.querySelector('input')?.checked));
        if (plans) plans.hidden = !subscribe;
        activeSellingPlanInput.disabled = !subscribe;
        activeSellingPlanInput.value = subscribe ? (selectedPlan?.value || '') : '';

        const selectedSupply = qs('[name="nyum_supply"]:checked', productRoot);
        const baseCents = Number(selectedSupply?.dataset.priceCents || 0);
        const planCents = Number(selectedPlan?.dataset.planPriceCents || baseCents);
        const discountPercent = Number(selectedPlan?.dataset.planDiscount || 0);
        const effectiveCents = subscribe ? planCents : baseCents;
        const effectivePrice = subscribe ? (selectedPlan?.dataset.planPrice || money(effectiveCents)) : (selectedSupply?.dataset.price || money(baseCents));
        const planSavingsCents = Number(selectedPlan?.dataset.planSavingsCents || Math.max(0, baseCents - planCents));
        const savingsCents = subscribe ? planSavingsCents : 0;
        const savingsPrice = selectedPlan?.dataset.planSavings || money(planSavingsCents);
        const planLabel = discountPercent > 0 ? `SUBSCRIBE & SAVE ${discountPercent}%` : 'AUTOMATIC DELIVERY';
        const interval = cadenceLabel(selectedPlan?.dataset.planInterval || '');
        const ctaLabel = selectedSupply?.dataset.ctaLabel || selectedSupply?.dataset.label || 'TO BAG';
        const unitName = String(selectedSupply?.dataset.unitName || 'bottle').toLowerCase();

        const subscriptionLabelNode = qs('[data-nyum-subscription-label]', subscriptionRoot);
        const subscriptionPriceNode = qs('[data-nyum-subscription-price]', subscriptionRoot);
        const subscriptionSavingsNode = qs('[data-nyum-subscription-savings]', subscriptionRoot);
        const subscriptionSupportNode = qs('[data-nyum-subscription-support]', subscriptionRoot);
        if (subscriptionLabelNode) subscriptionLabelNode.textContent = planLabel;
        if (subscriptionPriceNode) subscriptionPriceNode.textContent = selectedPlan?.dataset.planPrice || money(planCents);
        if (subscriptionSavingsNode) subscriptionSavingsNode.textContent = planSavingsCents > 0 ? `SAVE ${savingsPrice} EVERY DELIVERY` : 'RECURRING CONVENIENCE';
        if (subscriptionSupportNode) subscriptionSupportNode.textContent = `${discountPercent > 0 ? `Save ${discountPercent}% on every delivery · ` : ''}Skip, pause, or cancel anytime`;

        if (singleSelected && addButton) addButton.textContent = `ADD ${ctaLabel} · ${effectivePrice} →`;
        if (singleSelected && stickyPrice) stickyPrice.textContent = effectivePrice;
        if (singleSelected && stickyLabel) stickyLabel.textContent = subscribe
          ? `${planLabel}${interval ? ` · ${interval}` : ''}`
          : `${selectedSupply?.dataset.label || ''} · ${selectedSupply?.dataset.title || ''}`;
        if (singleSelected && valueLine) {
          valueLine.textContent = subscribe
            ? `${planLabel}${interval ? ` · ${interval}` : ''} · ${effectivePrice}/${unitName}${savingsCents > 0 ? ` · Save ${savingsPrice} every delivery` : ''}`
            : (selectedSupply?.dataset.valueLine || '');
        }

        if (subscribe) track('subscription_selected', { product: productRoot.dataset.productHandle, selling_plan: activeSellingPlanInput.value, discount_percent: discountPercent, interval });
      };
      purchaseRadios.forEach(radio => radio.addEventListener('change', syncPurchaseType));
      planRadios.forEach(radio => radio.addEventListener('change', syncPurchaseType));
      qsa('[name="nyum_supply"]', productRoot).forEach(radio => radio.addEventListener('change', syncPurchaseType));
      let sealResyncQueued = false;
      const sealObserver = new MutationObserver(mutations => {
        const sellingPlanChanged = mutations.some(mutation =>
          [...mutation.addedNodes].some(node =>
            node.nodeType === 1 && (node.matches?.('[name="selling_plan"], .sealsubs-target-element') || node.querySelector?.('[name="selling_plan"], .sealsubs-target-element'))
          )
        );
        if (!sellingPlanChanged || sealResyncQueued) return;
        sealResyncQueued = true;
        queueMicrotask(() => {
          sealResyncQueued = false;
          syncPurchaseType();
        });
      });
      sealObserver.observe(productForm, { childList: true, subtree: true });
      syncPurchaseType();
    }
    qs('[data-nyum-sticky-submit]', productRoot)?.addEventListener('click', () => productForm?.requestSubmit());
    const mainImage = qs('[data-nyum-main-product-image]', productRoot);
    qsa('[data-nyum-gallery-src]', productRoot).forEach(button => button.addEventListener('click', () => {
      qsa('[data-nyum-gallery-src]', productRoot).forEach(item => item.classList.remove('is-active'));
      button.classList.add('is-active');
      if (mainImage) mainImage.src = button.dataset.nyumGallerySrc;
    }));
    const sticky = qs('[data-nyum-pdp-sticky]', productRoot);
    if (productForm && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 }).observe(productForm);
    }
  }

  qsa('[data-nyum-track]').forEach(link => link.addEventListener('click', () => track(link.dataset.nyumTrack || 'link_clicked', { product: productRoot?.dataset.productHandle || '' })));
  const hero = qs('[data-nyum-hero]');
  if (hero) track('hero_viewed', { variant: hero.dataset.nyumHero || 'default' });
  const campaignLanding = qs('[data-nyum-campaign]');
  if (campaignLanding) track('campaign_landing_viewed', { campaign: campaignLanding.dataset.nyumCampaign || 'force' });
  const forceFilm = qs('[data-nyum-force-film]');
  if (forceFilm) {
    const forceVideo = qs('video', forceFilm);
    const filmIsDesktop = () => window.matchMedia('(min-width: 701px)').matches;
    const filmIsInView = () => {
      const rect = forceFilm.getBoundingClientRect();
      return rect.bottom > -180 && rect.top < window.innerHeight + 180;
    };
    const playForceFilm = () => {
      if (!forceVideo || !filmIsDesktop() || document.hidden || !filmIsInView()) return;
      forceVideo.muted = true;
      forceVideo.defaultMuted = true;
      forceVideo.setAttribute('muted', '');
      const playback = forceVideo.play();
      if (playback && typeof playback.catch === 'function') playback.catch(() => {});
    };

    if (forceVideo) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) playForceFilm();
          else if (!forceVideo.paused) forceVideo.pause();
        }, { rootMargin: '180px 0px', threshold: .01 }).observe(forceVideo);
      } else {
        playForceFilm();
      }
      forceVideo.addEventListener('canplay', playForceFilm, { once: true });
      window.addEventListener('pageshow', playForceFilm);
      document.addEventListener('visibilitychange', playForceFilm);
    }

    if ('IntersectionObserver' in window) {
      let filmSeen = false;
      new IntersectionObserver(([entry], observer) => {
        if (!filmSeen && entry.isIntersecting) {
          filmSeen = true;
          track('force_film_viewed', { placement: 'homepage_lower' });
          observer.disconnect();
        }
      }, { threshold: .45 }).observe(forceFilm);
    }
  }
  const comparison = qs('[data-nyum-comparison]');
  if (comparison && 'IntersectionObserver' in window) {
    let seen = false;
    new IntersectionObserver(([entry], observer) => {
      if (!seen && entry.isIntersecting) { seen = true; track('comparison_viewed', { product: productRoot?.dataset.productHandle || '' }); observer.disconnect(); }
    }, { threshold: .25 }).observe(comparison);
  }

  const atlanticStory = qs('[data-nyum-atlantic-story]');
  if (atlanticStory) {
    const atlanticMap = qs('[data-nyum-atlantic-map]', atlanticStory);
    const atlanticCards = qsa('[data-nyum-atlantic-card]', atlanticStory);
    atlanticCards.forEach(card => card.addEventListener('toggle', () => {
      if (!card.open) return;
      atlanticCards.forEach(other => { if (other !== card) other.open = false; });
      if (atlanticMap) atlanticMap.dataset.nyumAtlanticMapState = card.dataset.mapState || 'ocean';
      track('atlantic_evidence_opened', { proof_point: card.dataset.mapState || 'ocean' });
    }));

    const proofNumbers = qsa('[data-nyum-proof-number]', atlanticStory);
    const paintProofNumber = (node, progress = 1) => {
      const value = Number(node.dataset.proofValue || 0) * progress;
      const decimals = Number(node.dataset.proofDecimals || 0);
      const prefix = node.dataset.proofPrefix || '';
      const suffix = node.dataset.proofSuffix || '';
      node.textContent = `${prefix}${value.toFixed(decimals)}${suffix}`;
    };
    const finishProofNumbers = () => proofNumbers.forEach(node => paintProofNumber(node));
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      finishProofNumbers();
    } else {
      let proofPlayed = false;
      const metrics = qs('.nyum-v2-atlantic-metrics', atlanticStory);
      if (metrics) new IntersectionObserver(([entry], observer) => {
        if (proofPlayed || !entry.isIntersecting) return;
        proofPlayed = true;
        observer.disconnect();
        const started = performance.now();
        const duration = 760;
        const tick = now => {
          const progress = Math.min(1, (now - started) / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          proofNumbers.forEach(node => paintProofNumber(node, eased));
          if (progress < 1) requestAnimationFrame(tick);
          else finishProofNumbers();
        };
        requestAnimationFrame(tick);
      }, { threshold: .32 }).observe(metrics);
    }

    const atlanticSticky = qs('[data-nyum-pdp-sticky]', productRoot || document);
    if (atlanticSticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => atlanticSticky.classList.toggle('is-atlantic-paused', entry.isIntersecting), { threshold: .08 }).observe(atlanticStory);
    }
  }

  const reviewTarget = qs('[data-nyum-vitals-target]');
  if (reviewTarget) {
    const placeReviews = () => {
      const widget = qsa('.vtl-pr-main-widget, [data-vitals-product-reviews], .vitals-product-reviews').find(node => !reviewTarget.contains(node));
      if (!widget) return false;
      reviewTarget.innerHTML = '';
      reviewTarget.appendChild(widget);
      const reviewSection = reviewTarget.closest('.nyum-v2-reviews');
      const reviewHeading = qs('[data-nyum-review-heading]', reviewSection);
      const reviewCopy = qs('[data-nyum-review-copy]', reviewSection);
      const syncReviewState = () => {
        const widgetText = widget.innerText || '';
        const emptyReviews = !!qs('.vtl-pr-stats--no-reviews', widget) || /(?:^|\s)0\s+reviews\b|no reviews yet/i.test(widgetText);
        reviewSection?.classList.toggle('is-empty', emptyReviews);
        const score = qs('.vtl-pr-totals__score, [class*="totals__score"]', widget)?.textContent?.trim() || '';
        const countMatch = widgetText.match(/(\d+)\s+(?:verified\s+)?reviews?/i);
        const ratingCopy = qs('[data-nyum-rating-copy]');
        if (!emptyReviews && ratingCopy) {
          const count = Number(countMatch?.[1] || 0);
          ratingCopy.textContent = [score, count ? count + ' VERIFIED ' + (count === 1 ? 'REVIEW' : 'REVIEWS') : 'VERIFIED REVIEWS'].filter(Boolean).join(' · ');
        }
        if (emptyReviews) {
          if (reviewHeading) reviewHeading.innerHTML = 'Own the formula?<br>Leave the first note.';
          if (reviewCopy) reviewCopy.textContent = 'If this formula is already part of your routine, share what you chose it for and how it fits your day.';
        }
      };
      syncReviewState();
      const reviewStateObserver = new MutationObserver(syncReviewState);
      reviewStateObserver.observe(widget, { childList: true, subtree: true, characterData: true });
      window.setTimeout(() => reviewStateObserver.disconnect(), 12000);
      return true;
    };
    if (!placeReviews()) {
      const observer = new MutationObserver(() => { if (placeReviews()) observer.disconnect(); });
      observer.observe(document.documentElement, { childList: true, subtree: true });
      window.setTimeout(() => {
        observer.disconnect();
        const loading = qs('[data-nyum-reviews-loading]', reviewTarget);
        if (loading) loading.textContent = 'Customer reviews will appear here as people share their routines.';
      }, 7000);
    }
  }

  const evidenceDeck = qs('[data-nyum-evidence-deck]');
  if (evidenceDeck) {
    const evidenceTrack = qs('[data-nyum-evidence-track]', evidenceDeck);
    const evidenceSlides = qsa('[data-nyum-evidence-slide]', evidenceDeck);
    const evidencePrev = qs('[data-nyum-evidence-prev]', evidenceDeck);
    const evidenceNext = qs('[data-nyum-evidence-next]', evidenceDeck);
    const evidenceProgress = qs('[data-nyum-evidence-progress]', evidenceDeck);
    const evidenceCount = qs('[data-nyum-evidence-count]', evidenceDeck);
    let evidenceIndex = 0;
    let evidenceStartX = null;
    const renderEvidence = (shouldTrack = false) => {
      if (!evidenceTrack || !evidenceSlides.length) return;
      evidenceTrack.style.transform = `translate3d(-${evidenceIndex * 100}%,0,0)`;
      if (evidenceProgress) evidenceProgress.style.width = `${((evidenceIndex + 1) / evidenceSlides.length) * 100}%`;
      if (evidenceCount) evidenceCount.textContent = `${String(evidenceIndex + 1).padStart(2, '0')} / ${String(evidenceSlides.length).padStart(2, '0')}`;
      if (evidencePrev) evidencePrev.disabled = evidenceIndex === 0;
      if (evidenceNext) evidenceNext.disabled = evidenceIndex === evidenceSlides.length - 1;
      if (shouldTrack) track('knowledge_slide_viewed', { slide: evidenceIndex + 1, total: evidenceSlides.length });
    };
    evidencePrev?.addEventListener('click', () => { evidenceIndex = Math.max(0, evidenceIndex - 1); renderEvidence(true); });
    evidenceNext?.addEventListener('click', () => { evidenceIndex = Math.min(evidenceSlides.length - 1, evidenceIndex + 1); renderEvidence(true); });
    evidenceTrack?.addEventListener('pointerdown', event => { evidenceStartX = event.clientX; });
    evidenceTrack?.addEventListener('pointerup', event => {
      if (evidenceStartX === null) return;
      const distance = event.clientX - evidenceStartX;
      evidenceStartX = null;
      if (Math.abs(distance) < 45) return;
      evidenceIndex = distance < 0 ? Math.min(evidenceSlides.length - 1, evidenceIndex + 1) : Math.max(0, evidenceIndex - 1);
      renderEvidence(true);
    });
    evidenceTrack?.addEventListener('pointercancel', () => { evidenceStartX = null; });
    renderEvidence();
  }

  const quiz = qs('[data-nyum-quiz]');
  if (quiz) {
    const steps = qsa('[data-nyum-quiz-step]', quiz);
    const next = qs('[data-nyum-quiz-next]', quiz);
    const back = qs('[data-nyum-quiz-back]', quiz);
    const progress = qs('[data-nyum-quiz-progress]', quiz);
    const stepLabel = qs('[data-nyum-quiz-step-label]', quiz);
    const percent = qs('[data-nyum-quiz-percent]', quiz);
    const formRoot = qs('[data-nyum-quiz-form]', quiz);
    const resultRoot = qs('[data-nyum-quiz-result]', quiz);
    const quizForm = qs('form', formRoot);
    let catalog = {};
    try { catalog = JSON.parse(qs('[data-nyum-quiz-products]', quiz)?.textContent || '{}'); }
    catch (error) { console.warn('Formula Finder product data could not be read.', error); }
    let index = 0;
    let started = false;
    let recommendation = { primary: null, support: null };

    const productFormat = handle => ({
      'fucoidanforce': 'capsules', 'fenvir': 'capsules', 'fucoidan-phoenix': 'capsules', 'organic-fucoidan': 'tablets',
      'organic-ksm-66-ashwagandha-gummies': 'gummies', 'organic-myco-x-mushroom-gummies': 'gummies',
      'ultra-r7-sea-moss-gummies': 'gummies', 'shilaforce': 'resin'
    }[handle] || 'formula');
    const details = {
      'fucoidanforce': { reason: 'You chose the fucoidan family and flagship depth. Fucoidan Force® pairs 75% HPLC-standardized organic fucoidan with Organic Reishi.' },
      'fenvir': { reason: 'You chose Nyum\'s broad botanical + nutrient system. Fenvir Advanced® brings together 18 label-disclosed actives across four complexes.' },
      'fucoidan-phoenix': { reason: 'You chose the fucoidan family and the most advanced concentration tier in the Nyum system.' },
      'organic-fucoidan': { reason: 'You chose the fucoidan family and an accessible daily starting point.' },
      'organic-ksm-66-ashwagandha-gummies': { reason: 'You chose a focused adaptogen routine in an easy daily gummy format.' },
      'organic-myco-x-mushroom-gummies': { reason: 'You chose functional mushrooms. MYCO-X™ delivers a ten-mushroom fruiting-body blend in a gummy.' },
      'ultra-r7-sea-moss-gummies': { reason: 'You chose a daily marine-mineral routine in an easy gummy format.' },
      'shilaforce': { reason: 'You chose a mineral resin ritual. ShilaForce™ is Nyum\'s purified Himalayan shilajit format.' }
    };

    const primaryHandleFor = answers => {
      if (answers.family === 'resin' || answers.format === 'resin') return 'shilaforce';
      if (answers.format === 'gummy') {
        if (answers.family === 'adaptogen') return 'organic-ksm-66-ashwagandha-gummies';
        if (answers.family === 'mushroom') return 'organic-myco-x-mushroom-gummies';
        return 'ultra-r7-sea-moss-gummies';
      }
      if (answers.family === 'botanical') return 'fenvir';
      if (answers.family === 'adaptogen') return 'organic-ksm-66-ashwagandha-gummies';
      if (answers.family === 'mushroom') return 'organic-myco-x-mushroom-gummies';
      if (answers.family === 'marine') return 'ultra-r7-sea-moss-gummies';
      if (answers.depth === 'simple') return 'organic-fucoidan';
      if (answers.depth === 'advanced') return 'fucoidan-phoenix';
      return 'fucoidanforce';
    };
    const supportHandleFor = answers => ({
      adaptogen: 'organic-ksm-66-ashwagandha-gummies',
      mushroom: 'organic-myco-x-mushroom-gummies',
      marine: 'ultra-r7-sea-moss-gummies'
    }[answers.support] || null);
    const variantFor = (product, supply) => {
      if (!product?.variants?.length) return null;
      const available = product.variants.filter(variant => variant.available);
      const pool = available.length ? available : product.variants;
      const pattern = supply === '90' ? /(2\s*\+\s*1\s*Free|3\s*Pack)/i : /^(1\s*(Bottle|Pack)|Single Bottle)$/i;
      return pool.find(variant => pattern.test(variant.title)) || pool[0];
    };
    const supplyLabelFor = variant => {
      if (!variant) return 'Unavailable';
      if (/2\s*\+\s*1\s*Free/i.test(variant.title)) return '2 + 1 Free · three bottles';
      if (/3\s*Pack/i.test(variant.title)) return '3-pack routine';
      if (variant.title === 'Default Title') return 'One-time purchase';
      return variant.title;
    };
    const choiceFor = (handle, supply) => {
      const product = catalog[handle];
      const variant = variantFor(product, supply);
      return product && variant ? { handle, product, variant, supplyLabel: supplyLabelFor(variant) } : null;
    };
    const formatNoteFor = (answers, choice) => {
      if (!choice || answers.format === 'best') return '';
      const actual = productFormat(choice.handle);
      const matches = (answers.format === 'capsule' && ['capsules', 'tablets'].includes(actual)) ||
        (answers.format === 'gummy' && actual === 'gummies') || (answers.format === 'resin' && actual === 'resin');
      return matches ? '' : ` Nyum's closest match for this formula family comes as ${actual}, so the formula priority leads this result.`;
    };

    const showStep = () => {
      steps.forEach((step, stepIndex) => step.hidden = stepIndex !== index);
      if (back) back.hidden = index === 0;
      if (next) next.textContent = index === steps.length - 1 ? 'BUILD MY ROUTINE →' : 'CONTINUE →';
      const completed = Math.round(((index + 1) / steps.length) * 100);
      if (progress) progress.style.width = `${completed}%`;
      if (stepLabel) stepLabel.textContent = `QUESTION ${index + 1} OF ${steps.length}`;
      if (percent) percent.textContent = `${completed}%`;
    };

    const renderChoice = (choice, role, reason) => {
      if (!choice) return;
      const image = qs(`[data-nyum-quiz-${role}-image]`, quiz);
      const name = qs(`[data-nyum-quiz-${role}-name]`, quiz);
      const reasonNode = qs(`[data-nyum-quiz-${role}-reason]`, quiz);
      const supply = qs(`[data-nyum-quiz-${role}-supply]`, quiz);
      const price = qs(`[data-nyum-quiz-${role}-price]`, quiz);
      const link = qs(`[data-nyum-quiz-${role}-link]`, quiz);
      const add = qs(role === 'primary' ? '[data-nyum-quiz-add-primary]' : '[data-nyum-quiz-add-support]', quiz);
      if (image) { image.src = choice.product.image || ''; image.alt = choice.product.title || ''; }
      if (name) name.textContent = choice.product.title || '';
      if (reasonNode) reasonNode.textContent = reason;
      if (supply) supply.textContent = choice.supplyLabel;
      if (price) price.textContent = money(Number(choice.variant.price || 0));
      if (link) link.href = choice.product.url || `/products/${choice.handle}`;
      if (add) {
        add.dataset.variant = choice.variant.id;
        add.dataset.handle = choice.handle;
        add.disabled = !choice.variant.available;
        add.textContent = choice.variant.available ? `ADD TO BAG · ${money(Number(choice.variant.price || 0))} →` : 'CURRENTLY UNAVAILABLE';
      }
    };

    const renderResult = answers => {
      const primaryHandle = primaryHandleFor(answers);
      const supportHandle = supportHandleFor(answers);
      const primary = choiceFor(primaryHandle, answers.supply);
      const support = supportHandle && supportHandle !== primaryHandle ? choiceFor(supportHandle, answers.supply) : null;
      recommendation = { primary, support };
      const primaryReason = `${details[primaryHandle]?.reason || 'This is the closest match in the Nyum formula system.'}${formatNoteFor(answers, primary)}`;
      renderChoice(primary, 'primary', primaryReason);
      const supportCard = qs('[data-nyum-quiz-support-card]', quiz);
      if (supportCard) {
        supportCard.hidden = !support;
        supportCard.style.display = support ? '' : 'none';
      }
      if (support) {
        const supportLabel = answers.support === 'adaptogen' ? 'adaptogen' : answers.support === 'mushroom' ? 'functional mushroom' : 'marine-mineral';
        renderChoice(support, 'support', `You selected ${supportLabel} support as the optional second layer of your routine.`);
      }
      const addBoth = qs('[data-nyum-quiz-add-both]', quiz);
      if (addBoth) {
        addBoth.hidden = !support;
        addBoth.disabled = !primary?.variant?.available || !support?.variant?.available;
        const routineTotal = Number(primary?.variant?.price || 0) + Number(support?.variant?.price || 0);
        addBoth.textContent = support ? `ADD THE FULL ROUTINE · ${money(routineTotal)} →` : 'ADD THE FULL ROUTINE →';
      }
      const summary = qs('[data-nyum-quiz-result-summary]', quiz);
      if (summary) {
        const offer = /2\s*\+\s*1\s*Free/i.test(primary?.variant?.title || '') ? ' Your bundle choice is mapped to the real 2 + 1 Free offer.' :
          /3\s*Pack/i.test(primary?.variant?.title || '') ? ' Your bundle choice is mapped to the real 3-pack.' : '';
        const focused = supportHandle && !support ? ' Your primary already covers the support priority you selected, so the result stays focused.' : '';
        summary.textContent = `Start with ${primary?.product?.title || 'the formula below'}.${offer}${focused}`;
      }
      if (formRoot) formRoot.hidden = true;
      if (resultRoot) resultRoot.hidden = false;
      if (progress) progress.style.width = '100%';
      if (stepLabel) stepLabel.textContent = 'YOUR RESULT';
      if (percent) percent.textContent = '100%';
      track('quiz_completed', { primary: primaryHandle, support: support?.handle || 'none', supply: answers.supply, family: answers.family, format: answers.format });
    };

    next?.addEventListener('click', () => {
      const current = steps[index];
      if (!qs('input:checked', current)) { current.classList.add('has-error'); return; }
      current.classList.remove('has-error');
      if (!started) { started = true; track('quiz_started'); }
      track('quiz_step_completed', { step: index + 1 });
      if (index < steps.length - 1) { index += 1; showStep(); return; }
      renderResult(Object.fromEntries(new FormData(quizForm).entries()));
    });
    back?.addEventListener('click', () => { if (index > 0) { index -= 1; showStep(); } });
    qs('[data-nyum-quiz-restart]', quiz)?.addEventListener('click', () => {
      quizForm?.reset();
      steps.forEach(step => step.classList.remove('has-error'));
      index = 0;
      recommendation = { primary: null, support: null };
      if (resultRoot) resultRoot.hidden = true;
      if (formRoot) formRoot.hidden = false;
      track('quiz_restarted');
      showStep();
    });

    const addQuizItems = async (choices, button, eventName) => {
      const chosen = choices.filter(Boolean);
      const items = chosen.map(choice => ({ id: Number(choice.variant.id), quantity: 1 }));
      if (!items.length || !button) return;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'ADDING…';
      try {
        await cartRequest('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        track(eventName, { products: chosen.map(choice => choice.handle).join(','), variants: chosen.map(choice => choice.variant.id).join(',') });
        await refreshCart();
        openCart();
      } catch (error) {
        console.warn(error);
        button.textContent = 'TRY AGAIN';
        button.disabled = false;
        return;
      }
      button.textContent = original;
      button.disabled = false;
    };
    qs('[data-nyum-quiz-add-primary]', quiz)?.addEventListener('click', event => addQuizItems([recommendation.primary], event.currentTarget, 'quiz_recommendation_added'));
    qs('[data-nyum-quiz-add-support]', quiz)?.addEventListener('click', event => addQuizItems([recommendation.support], event.currentTarget, 'quiz_support_added'));
    qs('[data-nyum-quiz-add-both]', quiz)?.addEventListener('click', event => addQuizItems([recommendation.primary, recommendation.support], event.currentTarget, 'quiz_routine_added'));
    showStep();
  }

  qsa('[data-nyum-counter]').forEach(counter => {
    const target = Number(counter.dataset.nyumCounter || 0);
    const suffix = counter.dataset.nyumSuffix || '';
    const finish = () => { counter.textContent = `${target}${suffix}`; };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { finish(); return; }
    let played = false;
    const play = () => {
      if (played) return;
      played = true;
      window.removeEventListener('scroll', check);
      const started = Date.now();
      const duration = 1050;
      const tick = () => {
        const progress = Math.min(1, (Date.now() - started) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        counter.textContent = `${Math.round(target * eased)}${suffix}`;
        if (progress >= 1) { clearInterval(timer); finish(); }
      };
      const timer = setInterval(tick, 24);
      tick();
    };
    const check = () => {
      const rect = counter.getBoundingClientRect();
      if (rect.top < window.innerHeight * .86 && rect.bottom > 0) play();
    };
    window.addEventListener('scroll', check, { passive: true });
    check();
  });

  const startShelf = qs('[data-nyum-start]');
  if (startShelf) {
    const startOrder = ['force', 'fenvir', 'organic', 'ksm'];
    const startTabs = qsa('[data-nyum-start-select]', startShelf);
    const startPanels = qsa('[data-nyum-start-panel]', startShelf);
    let activeStart = 'fenvir';
    const showStart = (key, shouldFocus = false) => {
      if (!startOrder.includes(key)) return;
      activeStart = key;
      startTabs.forEach(tab => {
        const active = tab.dataset.nyumStartSelect === key;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (active && shouldFocus) tab.focus({ preventScroll: true });
      });
      startPanels.forEach(panel => { panel.hidden = panel.dataset.nyumStartPanel !== key; });
      track('bestseller_spotlight_viewed', { product: key });
    };
    startTabs.forEach(tab => {
      tab.addEventListener('click', () => showStart(tab.dataset.nyumStartSelect));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const current = startOrder.indexOf(activeStart);
        const next = event.key === 'ArrowRight' ? (current + 1) % startOrder.length : (current - 1 + startOrder.length) % startOrder.length;
        showStart(startOrder[next], true);
      });
    });
    showStart(activeStart);
  }

  const tierCompare = qs('[data-nyum-tier-compare]');
  if (tierCompare) {
    const tierOrder = ['organic', 'force', 'phoenix'];
    const tierTabs = qsa('[data-nyum-tier-select]', tierCompare);
    const tierPanels = qsa('[data-nyum-tier-panel]', tierCompare);
    const tierCount = qs('[data-nyum-tier-count]', tierCompare);
    const tierProgress = qs('.nyum-tier-shop__controls span i', tierCompare);
    let activeTier = tierOrder.includes(tierCompare.dataset.activeTier) ? tierCompare.dataset.activeTier : 'force';

    const showTier = (tier, shouldFocus = false) => {
      if (!tierOrder.includes(tier)) return;
      activeTier = tier;
      tierCompare.dataset.activeTier = tier;
      tierTabs.forEach(tab => {
        const active = tab.dataset.nyumTierSelect === tier;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (active && shouldFocus) tab.focus({ preventScroll: true });
      });
      tierPanels.forEach(panel => { panel.hidden = panel.dataset.nyumTierPanel !== tier; });
      const index = tierOrder.indexOf(tier);
      if (tierCount) tierCount.textContent = `0${index + 1} / 03`;
      if (tierProgress) tierProgress.style.width = `${((index + 1) / tierOrder.length) * 100}%`;
      track('fucoidan_tier_viewed', { tier });
    };

    tierTabs.forEach(tab => {
      tab.addEventListener('click', () => showTier(tab.dataset.nyumTierSelect));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const current = tierOrder.indexOf(activeTier);
        const next = event.key === 'ArrowRight' ? (current + 1) % tierOrder.length : (current - 1 + tierOrder.length) % tierOrder.length;
        showTier(tierOrder[next], true);
      });
    });
    qs('[data-nyum-tier-prev]', tierCompare)?.addEventListener('click', () => {
      const current = tierOrder.indexOf(activeTier);
      showTier(tierOrder[(current - 1 + tierOrder.length) % tierOrder.length]);
    });
    qs('[data-nyum-tier-next]', tierCompare)?.addEventListener('click', () => {
      const current = tierOrder.indexOf(activeTier);
      showTier(tierOrder[(current + 1) % tierOrder.length]);
    });
    showTier(activeTier);
  }

  const shopRoot = qs('[data-nyum-shop]');
  if (shopRoot) {
    const buttons = qsa('[data-nyum-shop-filter]', shopRoot);
    const cards = qsa('[data-nyum-shop-card]', shopRoot);
    const count = qs('[data-nyum-visible-count]', shopRoot);
    const applyShopFilter = (filter, updateUrl = true) => {
      buttons.forEach(button => {
        const active = button.dataset.nyumShopFilter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      cards.forEach(card => { card.hidden = !String(card.dataset.categories || '').split(' ').includes(filter); });
      if (count) count.textContent = qsa('.nyum-shop-card:not([hidden])', shopRoot).length;
      if (updateUrl) {
        const url = new URL(window.location.href);
        if (filter === 'all') url.searchParams.delete('filter'); else url.searchParams.set('filter', filter);
        history.replaceState({}, '', url);
      }
    };
    buttons.forEach(button => button.addEventListener('click', () => applyShopFilter(button.dataset.nyumShopFilter)));
    const requested = new URLSearchParams(window.location.search).get('filter');
    const initial = buttons.some(button => button.dataset.nyumShopFilter === requested) ? requested : 'all';
    applyShopFilter(initial, false);
  }

  refreshCart();
})();
